import { useEffect } from 'react';
import { connect } from 'react-redux';
// import MultiSignalsFooter from '../../components/MultiSignalsFooter/MultiSignalsFooter';
import MultiSignalsNavbar from '../../components/MultiSignalsNavbar/MultiSignalsNavbar';
import './PublicLayout.scss';

function PublicLayout({ ...props }) {
  const { children } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  return (
    <div className="modern-public-layout">
      <MultiSignalsNavbar {...props} isPublic={true} />
      <main className="public-content">
        <div className="content-wrapper">
          {children}
        </div>
      </main>
      {/* <MultiSignalsFooter {...props} /> */}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps)(PublicLayout);